import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {RiskGroupInfo} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {Utils} from '@amlCore/utils';
import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';
import { first, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-registry-riskGroup-info',
  templateUrl: './riskGroupInfo.component.html'
})
export class RiskGroupInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  placeholder = 'Поиск по ИНН';
  private componentDestoyed$ = new Subject();
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private regSrv: RegistriesService,
              private resourceSrv: ResourceService,
              private userSrv: UserService,
              private alertSrv: AlertService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'sysRegDate', dir: 'DESC'});
  }

  public riskGroupInfoEntries: Array<RiskGroupInfo> = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_RISKGROUP);
    localStorage.removeItem('riskGroupSearch');
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
  }

  onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getRiskGroupInfo(queryParams).subscribe(data => {
      this.riskGroupInfoEntries = data.content;
      //Временное решение. После миграции всех документов оставить вариант с новым ответом от сервера
      this.total = data.totalElements ?? data.numberOfElements;
      this.scrollRun();
    });
  }

  showSubjList(item: RiskGroupInfo) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/riskGroupSubject', item.id]);
  }

  onSearch() {
    const params = this.getSearchPage(this.filter);
    const queryParams = this.getFilterObject(params);
    queryParams["sort"] = "riskDate";
    queryParams["dir"] = "ASC";
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/riskGroupSubject'], {
      queryParams: {q: Utils.encodeJSONBase64(queryParams)} as Params
    });
  }

  remove(confirm, riskGroup: RiskGroupInfo) {
    this.alertSrv.clear();

    this.userSrv.getLicense()
      .pipe(map(license => license.modules),
            takeUntil(this.componentDestoyed$),
            first())
      .subscribe(modules => {
        const url = modules.includes('aml') ?
                    `/api/v1/qref/riskgroup/remove?id=${riskGroup.id}` :
                    `/api/v1/cls/kyc/remove/?id=${riskGroup.id}`;

        this.regSrv.removeFile(url)
          .pipe(takeUntil(this.componentDestoyed$),
                first())
          .subscribe(() => {
            this.alertSrv.success(`Запись ${riskGroup.fileName} удалена!`);
            this.loadList();
          });
      });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  checkRiskFactor(item: RiskGroupInfo) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.RISK_GROUP, this.loadCheckList, this.alertObjToCheck);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  ngOnDestroy() {
    this.checkScrollOptions();

    this.componentDestoyed$.next();
    this.componentDestoyed$.complete();
  }

}
